import { render, staticRenderFns } from "./TableSeplag.vue?vue&type=template&id=72d122b2&scoped=true&"
import script from "./TableSeplag.vue?vue&type=script&lang=js&"
export * from "./TableSeplag.vue?vue&type=script&lang=js&"
import style0 from "./TableSeplag.vue?vue&type=style&index=0&id=72d122b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d122b2",
  null
  
)

export default component.exports